import React from 'react'
import { Motion, spring } from 'react-motion'
import SelectedLink from 'lib/components/selected-link'

class EasingDiamond extends React.PureComponent {
  static defaultProps = {
    precision: 0.1,
    stiffness: 130,
    damping: 19,
    opacity: 1
  }

  constructor(props, context) {
    super(props, context)

    this.defaultStyle = {
      x: props.x,
      y: props.y,
      r: 0
    }
  }

  renderDiamond({ x, y, r }) {
    var d = `M${x - r},${y} L${x},${y - r} L${x + r},${y} L${x},${y + r} Z`

    return (
      <path className="easing-diamond" d={d} opacity={this.props.opacity} />
    )
  }

  render() {
    const {
      isLink,
      x,
      y,
      r,
      fill,
      label,
      precision,
      damping,
      stiffness,
      isActive,
      id
    } = this.props

    const SPRING = { precision, damping, stiffness }

    const style = {
      x: spring(x, SPRING),
      y: spring(y, SPRING),
      r: spring(r, { damping: 13, stiffness: 100, precision: SPRING.precision })
    }

    const shape = (
      <g fill={fill}>
        <title>{label}</title>

        <Motion defaultStyle={this.defaultStyle} style={style}>
          {style => this.renderDiamond(style)}
        </Motion>
      </g>
    )

    if (isLink) {
      return (
        <SelectedLink
          selected={id}
          isActive={isActive}
          track={label}
          trackAs="chart-item"
          avoidHref={true}
        >
          {shape}
        </SelectedLink>
      )
    }

    return shape
  }
}

export default EasingDiamond



// WEBPACK FOOTER //
// ./src/components/charts/shapes/easing-diamond.js